import { AspectType, AspectTypeBase } from '@lib.core/entities/indicator-type/indicator-type';

export interface AspectTypeDTO extends AspectTypeBase {
  createdAt: string;
  lastUpdatedAt?: string;
}

export function newAspectTypeFromDto(dto: AspectTypeDTO): AspectType {
  return {
    id: dto.id,
    nameid: dto.nameid,
    title: dto.title,
    createdAt: new Date(dto.createdAt),
    lastUpdatedAt: dto.lastUpdatedAt ? new Date(dto.lastUpdatedAt!) : undefined
  }
}

export class AspectTypeDTOConverter {
  static aspectTypeFromDTO(dto: AspectTypeDTO): AspectType {
    const { createdAt, lastUpdatedAt, ...rest } = dto;
    return {
      ...rest,
      createdAt: new Date(createdAt),
      ...(lastUpdatedAt && { lastUpdatedAt: new Date(lastUpdatedAt) }),
    };
  }
}

export interface AspectTypeSaveDTO {
  nameid?: string;
  title?: string;
}
